import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

export default class extends Controller {
  static values = {
    data: Array,
    title: String
  }

  connect() {
    this.initializeChart()
  }

  // Détruit l'instance Chart.js au démontage du contrôleur (navigation Turbo)
  // pour éviter une fuite mémoire cumulative (canvas + listeners conservés).
  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }

  initializeChart() {
    if (this.dataValue.length === 0) return

    const ctx = this.element.getContext("2d")
    const chartData = this.dataValue[0]

    this.chart = new Chart(ctx, {
      type: "radar",
      data: {
        labels: chartData.labels,
        datasets: chartData.datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          r: {
            min: 0,
            max: 4,
            ticks: {
              stepSize: 1
            }
          }
        },
        plugins: {
          title: {
            display: true,
            text: this.titleValue,
            padding: 20,
            font: {
              size: 16
            }
          },
          legend: {
            display: true,
            position: "top"
          }
        }
      }
    })
  }
}
